
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $6e4b1c7e784a67da$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["3tjkn","index.e55ac2ec.js","bzP66","blue-icon.c1b280f0.png","kWgJ6","gray-icon.0b2164b9.png","57KK1","orange-icon.10656dd1.png","aWUA0","debuggerWorker.212ead39.js","2E44I","index.42151b07.css"]'));

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /* eslint-env browser */ 
var $599ada5805f713f0$exports = {};
$599ada5805f713f0$exports = new URL("blue-icon.c1b280f0.png", import.meta.url).toString();


var $2123e26c88ba683a$exports = {};
$2123e26c88ba683a$exports = new URL("gray-icon.0b2164b9.png", import.meta.url).toString();


var $133fa99110e4507f$exports = {};
$133fa99110e4507f$exports = new URL("orange-icon.10656dd1.png", import.meta.url).toString();


const $bdbb038b2924bf56$var$isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
const $bdbb038b2924bf56$var$refreshShortcut = $bdbb038b2924bf56$var$isMacLike ? "\u2318R" : "Ctrl R";
window.onload = function() {
    if (!$bdbb038b2924bf56$var$isMacLike) document.getElementById("shortcut").innerHTML = "Ctrl\u21E7J";
    $bdbb038b2924bf56$var$Page.render();
};
window.onReloadClicked = function() {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", `${window.location.origin}/reload`, true);
    xhr.send();
};
const $bdbb038b2924bf56$var$Page = window.Page = {
    state: {
        isDark: localStorage.getItem("darkTheme") === null ? window.matchMedia("(prefers-color-scheme: dark)").matches : localStorage.getItem("darkTheme") === "on",
        isPriorityMaintained: localStorage.getItem("maintainPriority") === "on",
        status: {
            type: "disconnected"
        },
        visibilityState: document.visibilityState
    },
    setState (partialState) {
        $bdbb038b2924bf56$var$Page.state = Object.assign({}, $bdbb038b2924bf56$var$Page.state, partialState);
        $bdbb038b2924bf56$var$Page.render();
    },
    render () {
        const { isDark: isDark, isPriorityMaintained: isPriorityMaintained, status: status, visibilityState: visibilityState } = $bdbb038b2924bf56$var$Page.state;
        const statusNode = document.getElementById("status");
        switch(status.type){
            case "connected":
                statusNode.textContent = "Debugger session active.";
                break;
            case "error":
                statusNode.textContent = status.error.reason || "Disconnected from proxy. Attempting reconnection. Is node server running?";
                break;
            case "connecting":
            case "disconnected":
            // Fall through.
            default:
                statusNode.innerHTML = 'Waiting, press <span class="shortcut">' + $bdbb038b2924bf56$var$refreshShortcut + "</span> in simulator to reload and connect.";
                break;
        }
        const linkNode = document.querySelector("link[rel=icon]");
        if (status.type === "disconnected" || status.type === "error") linkNode.href = (0, (/*@__PURE__*/$parcel$interopDefault($2123e26c88ba683a$exports)));
        else if (visibilityState === "visible" || isPriorityMaintained) linkNode.href = (0, (/*@__PURE__*/$parcel$interopDefault($599ada5805f713f0$exports)));
        else linkNode.href = (0, (/*@__PURE__*/$parcel$interopDefault($133fa99110e4507f$exports)));
        const darkCheckbox = document.getElementById("dark");
        document.body.classList.toggle("dark", isDark);
        darkCheckbox.checked = isDark;
        localStorage.setItem("darkTheme", isDark ? "on" : "");
        const maintainPriorityCheckbox = document.getElementById("maintain-priority");
        const silence = document.getElementById("silence");
        silence.volume = 0.1;
        if (isPriorityMaintained) silence.play();
        else silence.pause();
        maintainPriorityCheckbox.checked = isPriorityMaintained;
        localStorage.setItem("maintainPriority", isPriorityMaintained ? "on" : "");
    },
    toggleDarkTheme () {
        $bdbb038b2924bf56$var$Page.setState({
            isDark: !$bdbb038b2924bf56$var$Page.state.isDark
        });
    },
    togglePriorityMaintenance () {
        $bdbb038b2924bf56$var$Page.setState({
            isPriorityMaintained: !$bdbb038b2924bf56$var$Page.state.isPriorityMaintained
        });
    }
};
var $121e57bf6cb5ea11$exports = {};
$121e57bf6cb5ea11$exports = new URL("debuggerWorker.212ead39.js", import.meta.url).toString();


function $bdbb038b2924bf56$var$connectToDebuggerProxy() {
    const ws = new WebSocket("ws://" + window.location.host + "/debugger-proxy?role=debugger&name=Chrome");
    let worker;
    function createJSRuntime() {
        // This worker will run the application JavaScript code,
        // making sure that it's run in an environment without a global
        // document, to make it consistent with the JSC executor environment.
        const url = new URL($121e57bf6cb5ea11$exports);
        worker = new Worker(url);
        worker.onmessage = function(message) {
            ws.send(JSON.stringify(message.data));
        };
        window.onbeforeunload = function() {
            return "If you reload this page, it is going to break the debugging session. Press " + $bdbb038b2924bf56$var$refreshShortcut + " on the device to reload.";
        };
        updateVisibility();
    }
    function shutdownJSRuntime() {
        if (worker) {
            worker.terminate();
            worker = null;
            window.onbeforeunload = null;
        }
    }
    function updateVisibility() {
        if (worker && !$bdbb038b2924bf56$var$Page.state.isPriorityMaintained) worker.postMessage({
            method: "setDebuggerVisibility",
            visibilityState: document.visibilityState
        });
        $bdbb038b2924bf56$var$Page.setState({
            visibilityState: document.visibilityState
        });
    }
    ws.onopen = function() {
        $bdbb038b2924bf56$var$Page.setState({
            status: {
                type: "connecting"
            }
        });
    };
    ws.onmessage = async function(message) {
        if (!message.data) return;
        const object = JSON.parse(message.data);
        if (object.$event === "client-disconnected") {
            shutdownJSRuntime();
            $bdbb038b2924bf56$var$Page.setState({
                status: {
                    type: "disconnected"
                }
            });
            return;
        }
        if (!object.method) return;
        // Special message that asks for a new JS runtime
        if (object.method === "prepareJSRuntime") {
            shutdownJSRuntime();
            console.clear();
            createJSRuntime();
            ws.send(JSON.stringify({
                replyID: object.id
            }));
            $bdbb038b2924bf56$var$Page.setState({
                status: {
                    type: "connected",
                    id: object.id
                }
            });
        } else if (object.method === "$disconnected") {
            shutdownJSRuntime();
            $bdbb038b2924bf56$var$Page.setState({
                status: {
                    type: "disconnected"
                }
            });
        } else worker.postMessage(object);
    };
    ws.onclose = function(error) {
        shutdownJSRuntime();
        $bdbb038b2924bf56$var$Page.setState({
            status: {
                type: "error",
                error: error
            }
        });
        if (error.reason) console.warn(error.reason);
        setTimeout($bdbb038b2924bf56$var$connectToDebuggerProxy, 500);
    };
    // Let debuggerWorker.js know when we're not visible so that we can warn about
    // poor performance when using remote debugging.
    document.addEventListener("visibilitychange", updateVisibility, false);
}
$bdbb038b2924bf56$var$connectToDebuggerProxy();


//# sourceMappingURL=index.e55ac2ec.js.map
